{
    "Policies.home": "Home",
    "Policies.dashboard": "Dashboard",
    "Policies.policies": "Policies",
    "Policies.bordereaux": "Bordereaux",
    "Policies.newquote": "New Quote",
    "Policies.leads": "Leads",
    "Policies.search": "Clients",
    "Policies.allBrokers": "All Brokers",
    "Policies.allBrokerage": "All Brokerage"
}
